<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <b-field label="Tipo Entrega">
            <span class="has-text-weight-bold is-size-5">{{
              model.nombre
            }}</span>
          </b-field>
          <b-field v-if="esMonitor" label="Tipo Asignación">
            <span class="has-text-weight-bold is-size-5">{{
              model.tipoAsignacion
            }}</span>
          </b-field>
          <validation-provider
            v-else
            v-slot="{ errors, valid }"
            rules="required"
            :debounce="debounceFix"
          >
            <b-field
              label="Tipo Asignación"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-select
                v-model="model.tipoAsignacion"
                placeholder="Seleccione una opción..."
                expanded
              >
                <option
                  v-for="(item, index) in tiposAsignacion"
                  :key="`tipo-asignacion-${index}`"
                  :value="item"
                >
                  {{ item }}
                </option>
              </b-select>
            </b-field>
          </validation-provider>
          <div class="mt-3">
            <div v-if="esMonitor">
              <span>
                <b-icon
                  :icon="definirIcono(model.mostrarSinFacturar)"
                  class="mr-1"
                />
                Mostrar sin factura de anticipo?
              </span>
            </div>
            <validation-provider
              v-else
              v-slot="{ errors, valid }"
              :debounce="debounceFix"
            >
              <b-field
                :custom-class="'checkbox-input'"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-checkbox v-model="model.mostrarSinFacturar" type="is-info">
                  Mostrar sin factura de anticipo?
                </b-checkbox>
              </b-field>
            </validation-provider>
            <div v-if="esMonitor">
              <span>
                <b-icon :icon="definirIcono(model.puedePausar)" class="mr-1" />
                Se pueden pausar/reanudar los pedidos?
              </span>
            </div>
            <validation-provider
              v-else
              v-slot="{ errors, valid }"
              :debounce="debounceFix"
            >
              <b-field
                :custom-class="'checkbox-input'"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-checkbox v-model="model.puedePausar" type="is-info">
                  Se pueden pausar/reanudar los pedidos?
                </b-checkbox>
              </b-field>
            </validation-provider>
            <div v-if="esMonitor">
              <span>
                <b-icon :icon="definirIcono(model.usaSemaforo)" class="mr-1" />
                Usa colores en el tiempo transcurrido?
              </span>
            </div>
            <validation-provider
              v-else
              v-slot="{ errors, valid }"
              :debounce="debounceFix"
            >
              <b-field
                :custom-class="'checkbox-input'"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-checkbox v-model="model.usaSemaforo" type="is-info">
                  Usa colores en el tiempo transcurrido?
                </b-checkbox>
              </b-field>
            </validation-provider>
            <div v-if="esMonitor">
              <span>
                <b-icon
                  :icon="definirIcono(model.tieneEntregaPosterior)"
                  class="mr-1"
                />
                Usa agenda de entrega posterior?
              </span>
            </div>
            <validation-provider
              v-else
              v-slot="{ errors, valid }"
              :debounce="debounceFix"
            >
              <b-field
                :custom-class="'checkbox-input'"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-checkbox
                  v-model="model.tieneEntregaPosterior"
                  type="is-info"
                >
                  Usa agenda de entrega posterior?
                </b-checkbox>
              </b-field>
            </validation-provider>
          </div>
        </section>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button v-if="!esMonitor" type="is-info" @click="passes(submit)">
            <span>Guardar</span>
          </b-button>
          <button class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

import disponibilidadMixin from '@/mixins/disponibilidad.js'
import { tipoEntregaBodegaService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: 'TipoEntregaForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [disponibilidadMixin],
  props: {
    titulo: {
      type: String,
      default: 'Agregar Registro'
    },
    modificacion: {
      type: Boolean,
      default: false
    },
    bodega: {
      type: Number,
      default: 0
    },
    objeto: {
      type: Object,
      required: false,
      default: () => this.modeloInicial
    },
    esMonitor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.modeloInicial(),
      cargando: false,
      tiposAsignacion: ['Manual', 'Rotativa', 'Heredada']
    }
  },
  computed: {
    postModel() {
      return Object.assign(this.model, { bodegaId: this.bodega })
    },
    debounceFix() {
      return 0
    }
  },
  mounted() {
    this.model = Object.assign(this.model, this.objeto)
  },
  methods: {
    async submit() {
      const self = this
      try {
        await tipoEntregaBodegaService.updateTiposEntregaByBodegaAndTipoEntrega(
          self.bodega,
          self.objeto.id,
          self.postModel
        )
        self.notificarAccionCompletada(
          `Se ${
            this.modificacion ? 'modificó' : 'agregó'
          } el tipo de entrega correctamente`
        )
        self.$emit('close', true)
      } catch (error) {
        self.procesarError(error)
      }
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    resetForm() {
      this.model = this.modeloInicial
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    modeloInicial() {
      return {
        id: null,
        nombre: null,
        tipoAsignacion: null,
        mostrarSinFacturar: false,
        puedePausar: false,
        tieneEntregaPosterior: false,
        usaSemaforo: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-input {
  margin-top: 20px;
}
</style>
